/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ReplayIcon = ({ width = 24, height = 24, hidden = false, title = 'Replay' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.338 10.14a.878.878 0 0 0-.475-.14h-.931A.968.968 0 0 0 12 11v14a.968.968 0 0 0 .932 1h.931a.878.878 0 0 0 .475-.14l11.205-7a1.038 1.038 0 0 0 0-1.72Z"
    />
    <path
      d="m33.263 20.625-.986-.169a.494.494 0 0 0-.568.394A14 14 0 1 1 19.883 4.127a12.5 12.5 0 0 1 8.249 5.035l-1.985 1.984A.49.49 0 0 0 26 11.5a.5.5 0 0 0 .5.5h5.052a.5.5 0 0 0 .448-.447V6.5a.5.5 0 0 0-.5-.5.494.494 0 0 0-.35.147l-1.71 1.711a12.44 12.44 0 0 0-8.957-5.664A16 16 0 0 0 5.4 27.861a16 16 0 0 0 28.274-6.642.507.507 0 0 0-.411-.594Z"
    />
  </svg>`;
};
